import React, { useState } from "react"
import { Container, Row, Col, Form, Button, InputGroup, Spinner } from "react-bootstrap"
import { FaEye, FaEyeSlash } from "react-icons/fa"
import { loginUser } from "../../Services/userService"
import toast from "react-hot-toast"
import { userLogin } from "../../Redux/authSlice"
import { useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"

const Login = () => {
    const [userName, setUserName] = useState("")
    const [password, setPassword] = useState("")
    const [showPassword, setShowPassword] = useState(false)
    const [loading, setLoading] = useState(false)

    const dispatch = useDispatch()
    const navigate = useNavigate()


    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!userName || !password) {
            toast.error("Username and password required");
            return;
        }

        setLoading(true);


        try {
            const response = await dispatch(
                userLogin({ userName, password })
            ).unwrap();

            if (response?.status === "success") {
                toast.success(response?.message || "Login successful");
                setUserName("");
                setPassword("");

                // redirect after redux state updated
                navigate("/", { replace: true });
            } else {
                toast.error(response?.message || "Login failed");
            }

        } catch (error) {
            // error from rejectWithValue
            toast.error(error || "Server error");
            console.log("Login error:", error);
        } finally {
            setLoading(false);
        }
    };


    return (
        <Container className="vh-100 d-flex align-items-center justify-content-center">
            <Row className="w-100 justify-content-center">
                <Col md={4}>
                    <div className="border rounded p-4 shadow">
                        <h4 className="text-center mb-4">Login</h4>

                        <Form onSubmit={handleSubmit}>
                            {/* Username */}
                            <Form.Group className="mb-3">
                                <Form.Label>Username</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter username"
                                    value={userName}
                                    onChange={(e) => setUserName(e.target.value)}
                                />
                            </Form.Group>

                            {/* Password */}
                            <Form.Group className="mb-3">
                                <Form.Label>Password</Form.Label>
                                <InputGroup>
                                    <Form.Control
                                        type={showPassword ? "text" : "password"}
                                        placeholder="Enter password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                    />
                                    <InputGroup.Text
                                        style={{ cursor: "pointer" }}
                                        onClick={() => setShowPassword(!showPassword)}
                                    >
                                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                                    </InputGroup.Text>
                                </InputGroup>
                            </Form.Group>

                            <Button type="submit" variant="primary" className="w-100">
                                {
                                    loading ?
                                        <>
                                            <Spinner size="sm" animation="border" />
                                        </>
                                        : "Login"
                                }
                            </Button>
                        </Form>
                    </div>
                </Col>
            </Row>
        </Container>
    )
}

export default Login
